export default {
      id: "business-tags-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite-46b249.svg#business-tags-usage",
      toString: function () {
        return this.url;
      }
    }